import Vue from "vue"
import swal from "sweetalert2";

Vue.filter('price', function (value, options = {}) {
    return new Intl.NumberFormat('ro-RO', Object.assign({ style: 'currency', currency: 'RON', minimumFractionDigits: 2}, options)).format(Number(value));
})
Vue.filter('number', function (value, options = { maximumFractionDigits: 2}) {
    return new Intl.NumberFormat('ro-RO', options).format(Number(value));
})
Vue.filter('date', function (value) {
    return new Intl.DateTimeFormat('ro-RO', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    }).format(value);
})

Vue.filter('datetime', function (value) {
    try {
        return new Intl.DateTimeFormat('ro-RO', {
            timeStyle: 'short',
            dateStyle: 'full'
        }).format(value);
    } catch (e) {
        console.error(e)
        return value
    }
})
Vue.filter('shortdatetime', function (value) {
    try {
        return window.moment(value).format('DD.MM, HH:mm');
    } catch (e) {
        console.error(e)
        return value
    }
})
Vue.filter('shorttime', function (value) {
    try {
        return new Intl.DateTimeFormat('ro-RO', {
            timeStyle: 'short',
            dateStyle: undefined
        }).format(value);
    } catch (e) {
        console.error(e)
        return value
    }
})
Vue.filter('shortdate', function (value) {
    try {
        return new Intl.DateTimeFormat('ro-RO', {
            timeStyle: undefined,
            dateStyle: 'short'
        }).format(value);
    } catch (e) {
        console.error(e)
        return value
    }
})

Vue.mixin({
    computed: {
        colorScheme() {
            return [
                "#25CCF7","#FD7272","#54a0ff","#00d2d3",
                "#1abc9c","#2ecc71","#3498db","#9b59b6","#34495e",
                "#16a085","#27ae60","#2980b9","#8e44ad","#2c3e50",
                "#f1c40f","#e67e22","#e74c3c","#ecf0f1","#95a5a6",
                "#f39c12","#d35400","#c0392b","#bdc3c7","#7f8c8d",
                "#55efc4","#81ecec","#74b9ff","#a29bfe","#dfe6e9",
                "#00b894","#00cec9","#0984e3","#6c5ce7","#ffeaa7",
                "#fab1a0","#ff7675","#fd79a8","#fdcb6e","#e17055",
                "#d63031","#feca57","#5f27cd","#54a0ff","#01a3a4"
            ]
        },
        generalPaymentTypes() {
            return {
                'TICKET': 'Tichet',
                'CASH': 'Numerar',
                'BANK_TRANSFER': 'Transfer bancar',
            }
        },

        userAgent() {
            var userAgent = navigator.userAgent
                || navigator.vendor
                || window.opera
                || null;

            if (!userAgent)
                throw new Error('Failed to look for user agent information.');

            return userAgent;
        },
        isMobile () {
            var userAgent = this.userAgent;
            var userAgentPart = userAgent.substr(0, 4);
            return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(userAgent)
                || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgentPart);
        },
        isMobileOrTablet () {
            var userAgent = this.userAgent;
            var userAgentPart = userAgent.substr(0, 4);
            return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(userAgent)
                || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgentPart);
        }
    },
    methods: {
        showError(title = 'Va rugam sa verificati datele introduse.') {
            const validationModal = swal.mixin({
                confirmButtonClass: "v-btn blue-grey  subheading white--text",
                buttonsStyling: false
            });
            validationModal.fire({
                title: `Eroare`,
                html: `<p class="title">${title}</p>`,
                type: "warning",
                confirmButtonText: "Inapoi"
            });
        },
        showSuccess(text = 'Datele au fost salvate cu success!') {
            const successModal = swal.mixin({
                confirmButtonClass: "ml-2 v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default primary",
                buttonsStyling: false
            });
            successModal.fire({
                title: "Success!",
                html: `<p class="title">${text}</p>`,
                type: "success",
                confirmButtonText: "Inapoi"
            });
        },
        async asyncForEach(array, callback) {
            for (let index = 0; index < array.length; index++) {
                await callback(array[index], index, array);
            }
        },
        async uploadFile(path, files) {
            var formData = new FormData();
            files.forEach((item) => {
                formData.append(item.name, item.file);
            })
            return window.axios.post(path, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        },
        getConfig(key, fallback) {
            return this.$store.getters['workstation/getConfig'](key, fallback)
        },
        async getPossibleDeliveryIntervals(orderId)
        {
            const workstationId = window.vm.$store.getters['workstation/getWorkstationId'] || 1
            return window.axios.get(`${window.App.api_endpoint}/api/${workstationId}/orders/deliveryTimeRanges`, {
                query: {
                    orderId
                }
            })
            .then(({data}) => data)
        }
    }
})
